export const COLUMN_KEYS = [
    "priority",
    "rush",
    "premiumEditing",
    "locationDataSource",
    "startDate",
    "dueDate",
    "client",
    "cxHClient",
    "binNumber",
    "upc",
    "location",
    "status",
    "lastOpened",
    "shipmentType",
    "notes",
];

export const DEFAULT_SORT = [
    {
        id: "due",
        desc: false,
    },
    {
        id: "isRush",
        desc: true,
    },
];

export const UUID_DEFINITIONS = {
    itemName: "1880918225320673",
    itemDescription: "1880918225320853",
};

export const MATCH_TYPES = {
    partialMatch: {
        label: "Partial Match",
        value: 1,
        prompt: "Are you sure you want to select 'Partial Match' for this product?",
    },
    exactMatch: {
        label: "Exact Match",
        value: 2,
        prompt: "Are you sure this packaging is the same as the matched version?",
        wipPrompt: "You have selected an Exact Match type. Do you wish to continue with the product already in progress?",
    },

    noMatch: {
        label: "No Match",
        value: 3,
        prompt: "You have selected a No Match type. Do you wish for this product to continue through standard Intake operations?",
    },
};

export const TASK_STATUSES = [
    { value: "all", text: "Show All" },
    { value: "to-do", text: "Open" },
    { value: "completed", text: "Completed" },
];
